import React from 'react'
import { useLocation } from 'react-router-dom'
import Main from '../../../components/HOC/Main'
import MemberForm from '../../../components/pages/MemberForm'

const EditMemberPage = () => {
    const location = useLocation();
    const { memberData } = location.state || {};
    return (
        <Main crumbs={[{ title: "admin users" }, { title: "update" }]}>
            <MemberForm defaultData={memberData} />
        </Main>
    )
}

export default EditMemberPage